/* Cautare AI: Enter / microfon -> Rafy (Shopify chat) in modul larg. 2026-10-12 */
(function () {
  var L = (document.documentElement.lang || 'ro').slice(0, 2);
  var T = {
    ro: { ph: 'Căutare AI • Spuneți-ne de ce aveți nevoie', mic: 'Căutare vocală', sr: 'ro-RO', hint: 'Apăsați Enter pentru a întreba', wa: 'Bună ziua! Aș dori să discut cu un coleg despre rafturi. Pagina:' },
    en: { ph: 'AI search • Tell us what you need', mic: 'Voice search', sr: 'en-US', hint: 'Press Enter to ask', wa: 'Hello! I would like to talk to a colleague about shelving. Page:' },
    hu: { ph: 'AI keresés • Mondja el, mire van szüksége', mic: 'Hangalapú keresés', sr: 'hu-HU', hint: 'Nyomja meg az Entert', wa: 'Jó napot! Szeretnék egy kollégával beszélni a polcokról. Oldal:' }
  }[L] || null;
  if (!T) T = { ph: 'Căutare AI • Spuneți-ne de ce aveți nevoie', mic: 'Căutare vocală', sr: 'ro-RO', hint: 'Apăsați Enter pentru a întreba', wa: 'Bună ziua! Aș dori să discut cu un coleg despre rafturi. Pagina:' };
  var WA_NR = '40762128833';
  var K1 = 'shopify-chat-size', K2 = 'shopify-chat-size-path', FLAG = 'rafy-search-wide';
  var SR = window.SpeechRecognition || window.webkitSpeechRecognition;

  var css = '.rafy-sf{position:relative}' +
    '.rafy-mic{position:absolute;top:50%;transform:translateY(-50%);right:46px;z-index:3;width:30px;height:30px;border:0;border-radius:50%;background:transparent;color:currentColor;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;opacity:.75}' +
    '.rafy-mic:hover{opacity:1;background:rgba(0,0,0,.06)}' +
    '.rafy-mic svg{width:18px;height:18px}' +
    '.rafy-mic.is-on{opacity:1;color:#e8590c;animation:rafyPulse 1s infinite}' +
    '.rafy-sf--drawer .rafy-mic{right:8px}' +
    '.header .searchform{width:clamp(340px,calc(100vw - 900px),560px)}' +
    '.header .searchform--form .search-field{--rafy-a:0deg;border:2px solid transparent;background:linear-gradient(#f6f6f7,#f6f6f7) padding-box,conic-gradient(from var(--rafy-a),#cf4f1a 0deg,#ee6d2c 70deg,#ff8652 140deg,#ffc8ab 164deg,#ffede5 180deg,#ffc8ab 196deg,#ff8652 220deg,#ee6d2c 290deg,#cf4f1a 360deg) border-box;animation:rafyBorder 3.5s linear infinite}' +
    '.header .searchform--form .search-field::placeholder{color:#3a3a44;opacity:1;font-weight:500}' +
    '.searchform--form .search-field{font-size:15px!important}@media (max-width:1067px){.searchform--form .search-field{font-size:16px!important}}' +
    '.header .searchform--form .search-field:focus{border-color:transparent;outline:none;box-shadow:0 0 0 3px rgba(238,109,44,.18)}' +
    '@property --rafy-a{syntax:"<angle>";initial-value:0deg;inherits:false}' +
    '@keyframes rafyBorder{to{--rafy-a:360deg}}' +
    '@media (prefers-reduced-motion:reduce){.header .searchform--form .search-field{animation:none}}' +
    '.rafy-ai-ico{transform-origin:50% 50%;animation:rafyTwinkle 2.4s ease-in-out infinite}' +
    '.thb-search-submit .rafy-ai-ico,.thb-quick-search .rafy-ai-ico{width:28px!important;height:28px!important;max-width:none!important;max-height:none!important;overflow:visible}' +
    '.rafy-ai-ico path:nth-of-type(2){animation:rafyStar 2.4s ease-in-out .8s infinite}' +
    '.rafy-ai-ico path:nth-of-type(3){animation:rafyStar 2.4s ease-in-out 1.6s infinite}' +
    '@keyframes rafyTwinkle{0%,100%{transform:scale(.88);filter:drop-shadow(0 0 0 rgba(255,134,82,0))}50%{transform:scale(1.12);filter:drop-shadow(0 0 4px rgba(255,134,82,.85)) brightness(1.12)}}' +
    '@keyframes rafyStar{0%,100%{opacity:.35}50%{opacity:1}}' +
    '@media (prefers-reduced-motion:reduce){.rafy-ai-ico,.rafy-ai-ico path{animation:none}}' +
    '@keyframes rafyPulse{50%{background:rgba(232,89,12,.15)}}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  function chat() { return document.querySelector('shopify-chat'); }

  /* butoanele proprii ale chatului: size-expand / size-contract */
  function sizeBtn(name) {
    var c = chat(), btn = null;
    if (!c || !c.shadowRoot) return null;
    (function find(root) {
      if (btn) return;
      var i = root.querySelector('shopify-chat-icon[name="' + name + '"]');
      if (i && i.closest('button')) { btn = i.closest('button'); return; }
      root.querySelectorAll('*').forEach(function (e) { if (e.shadowRoot) find(e.shadowRoot); });
    })(c.shadowRoot);
    return btn;
  }

  /* panoul Rafy: modul larg cu 30% mai mic; deschis din cautare = ancorat sub caseta de cautare */
  function sheet(txt) { try { var s = new CSSStyleSheet(); s.replaceSync(txt); return s; } catch (e) { return null; } }
  var SMALL = sheet(['chat', 'history', 'login'].map(function (v) {
    return ':host(:not([mode="managed"])[open][view="' + v + '"]) .desktop-layout .panel.panel--size-expanded';
  }).join(',') + '{--private-panel-cap-height:630px;--private-panel-optimal-height:calc(63dvh - var(--shopify-chat-activator-offset));width:clamp(320px,630px,90dvw)}');
  var ANCH = sheet('.panel{top:var(--rafy-top)!important;left:var(--rafy-left)!important;right:auto!important;bottom:auto!important;width:var(--rafy-w)!important;max-width:none!important;height:var(--rafy-h)!important;max-height:var(--rafy-h)!important;--private-panel-cap-height:var(--rafy-h);--private-panel-optimal-height:var(--rafy-h);transform-origin:top center}');
  var VARS = ['--rafy-top', '--rafy-left', '--rafy-w', '--rafy-h'];

  function runtimeRoot() {
    var c = chat(), root = null;
    if (!c || !c.shadowRoot) return null;
    (function f(r) {
      if (root) return;
      if (r.querySelector('.panel')) { root = r; return; }
      r.querySelectorAll('*').forEach(function (e) { if (e.shadowRoot) f(e.shadowRoot); });
    })(c.shadowRoot);
    return root;
  }

  function adopt(root, s, on) {
    if (!root || !s) return;
    var a = root.adoptedStyleSheets.filter(function (x) { return x !== s; });
    if (on) a.push(s);
    root.adoptedStyleSheets = a;
  }

  function anchorVars(c) {
    var vw = document.documentElement.clientWidth, vh = window.innerHeight;
    var inp = document.getElementById('header-search-input');
    var r = inp && inp.getBoundingClientRect();
    var top, left, w, h;
    if (r && r.width > 0 && vw >= 1000) {
      left = r.left; w = r.width; top = Math.max(12, r.bottom + 8);
      h = Math.min(630, vh - top - 16);
    } else {
      var hd = document.querySelector('.header');
      top = (hd ? Math.max(0, hd.getBoundingClientRect().bottom) : 0) + 4;
      left = 0; w = vw; h = vh - top;
    }
    h = Math.max(300, h);
    c.style.setProperty('--rafy-top', Math.round(top) + 'px');
    c.style.setProperty('--rafy-left', Math.round(left) + 'px');
    c.style.setProperty('--rafy-w', Math.round(w) + 'px');
    c.style.setProperty('--rafy-h', Math.round(h) + 'px');
  }

  function applyAnchor(on) {
    var c = chat();
    if (!c) return;
    if (on) anchorVars(c);
    else VARS.forEach(function (k) { c.style.removeProperty(k); });
    var tries = 0;
    (function go() {
      var root = runtimeRoot();
      if (root) { adopt(root, SMALL, true); adopt(root, ANCH, on); }
      else if (++tries < 40) setTimeout(go, 100);
    })();
  }

  function isWide() { try { return sessionStorage.getItem(FLAG) === '1'; } catch (e) { return false; } }

  window.addEventListener('resize', function () { var c = chat(); if (c && isWide() && c.hasAttribute('open')) anchorVars(c); });

  function clearWide() {
    try { sessionStorage.removeItem(K1); sessionStorage.removeItem(K2); sessionStorage.removeItem(FLAG); } catch (e) {}
  }

  function closeSearch(form) {
    var sf = form.closest('search-form');
    if (sf && typeof sf.close === 'function') { try { sf.close(); } catch (e) {} }
    var dr = document.getElementById('Search-Drawer');
    if (dr) dr.classList.remove('active');
    document.body.classList.remove('open-cc');
    var inp = form.querySelector('input[name="q"]');
    if (inp) inp.blur();
  }

  function ask(form, q, fromMic) {
    var c = chat();
    if (!c || typeof c.sendStarterMessage !== 'function') return false;
    try {
      sessionStorage.setItem(K1, 'expanded');
      sessionStorage.setItem(K2, location.pathname);
      sessionStorage.setItem(FLAG, '1');
    } catch (e) {}
    applyAnchor(true);
    var ex = sizeBtn('size-expand');
    if (ex) { try { ex.click(); } catch (e) {} }
    var p;
    try { p = c.sendStarterMessage(q.slice(0, 500), 'typed'); } catch (e) { clearWide(); return false; }
    closeSearch(form);
    if (p && p.catch) p.catch(function () {
      clearWide();
      var qi = form.querySelector('input[name="q"]');
      if (fromMic && qi) { qi.value = q; qi.placeholder = T.hint; qi.focus(); return; }
      form.dataset.rafyFallback = '1';
      form.submit();
    });
    return true;
  }

  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || !form.matches || !form.matches('form[action$="/search"]')) return;
    if (form.dataset.rafyFallback) return;
    var inp = form.querySelector('input[name="q"]');
    var q = inp ? inp.value.trim() : '';
    if (!q) return;
    if (ask(form, q)) { ev.preventDefault(); ev.stopImmediatePropagation(); }
  }, true);

  /* "Discutați pe chat cu echipa noastră" (view=legacy-contact) -> WhatsApp */
  function toWhatsApp(c) {
    var ua = navigator.userActivation;
    if (!ua || !ua.isActive) return; /* numai imediat dupa un clic real */
    var url = 'https://wa.me/' + WA_NR + '?text=' + encodeURIComponent(T.wa + ' ' + location.href);
    var w = null;
    try { w = window.open(url, '_blank'); } catch (e) {}
    if (!w) { location.href = url; return; }
    try { w.opener = null; } catch (e) {}
    try { c.close(); } catch (e) {}
  }

  function watchChat() {
    var c = chat();
    if (!c || c.dataset.rafyWatch) return;
    c.dataset.rafyWatch = '1';
    var lastView = c.getAttribute('view');
    new MutationObserver(function () {
      var v = c.getAttribute('view');
      if (v === 'legacy-contact' && lastView !== 'legacy-contact') toWhatsApp(c);
      lastView = v;
      var wide = isWide();
      if (wide && !c.hasAttribute('open')) {
        var ct = sizeBtn('size-contract');
        if (ct) { try { ct.click(); } catch (e) {} }
        clearWide();
        applyAnchor(false);
      } else if (c.hasAttribute('open')) {
        applyAnchor(wide);
      }
    }).observe(c, { attributes: true, attributeFilter: ['open', 'view'] });
  }

  function micIcon() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="2" width="6" height="12" rx="3"/><path d="M5 10a7 7 0 0 0 14 0"/><path d="M12 17v4"/><path d="M8 21h8"/></svg>';
  }

  /* simbol AI (sclipire) in locul lupei, cu gradientul din header */
  var icoN = 0;
  function aiIcon(size) {
    var g = 'rafyAiG' + (++icoN);
    return '<svg class="rafy-ai-ico" width="' + size + '" height="' + size + '" viewBox="0 0 24 24" aria-hidden="true"><defs><linearGradient id="' + g + '" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#5c0164"/><stop offset=".35" stop-color="#ee6d2c"/><stop offset="1" stop-color="#ff8652"/></linearGradient></defs><path fill="url(#' + g + ')" d="M12 2L13.9 7.6L19.5 9.5L13.9 11.4L12 17L10.1 11.4L4.5 9.5L10.1 7.6Z"/><path fill="url(#' + g + ')" d="M19 14L19.9 16.6L22.5 17.5L19.9 18.4L19 21L18.1 18.4L15.5 17.5L18.1 16.6Z"/><path fill="url(#' + g + ')" d="M5 1.5L5.6 3.4L7.5 4L5.6 4.6L5 6.5L4.4 4.6L2.5 4L4.4 3.4Z"/></svg>';
  }

  function swapIcons() {
    document.querySelectorAll('.thb-search-submit, .thb-quick-search').forEach(function (el) {
      if (el.dataset.rafyIco) return;
      var svg = el.querySelector('svg');
      if (!svg) return;
      el.dataset.rafyIco = '1';
      var s = Math.round(svg.getBoundingClientRect().width) || 20;
      svg.outerHTML = aiIcon(Math.max(20, s + 2));
    });
  }

  function setup(form) {
    if (form.dataset.rafySearch) return;
    form.dataset.rafySearch = '1';
    var inp = form.querySelector('input[name="q"]');
    if (!inp) return;
    inp.placeholder = T.ph;
    inp.setAttribute('aria-label', T.ph);
    if (!SR) return;
    var fs = inp.parentElement;
    fs.classList.add('rafy-sf');
    if (!form.closest('search-form') || form.closest('#Search-Drawer')) fs.classList.add('rafy-sf--drawer');
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'rafy-mic';
    b.setAttribute('aria-label', T.mic);
    b.title = T.mic;
    b.innerHTML = micIcon();
    fs.appendChild(b);
    if (!fs.classList.contains('rafy-sf--drawer')) inp.style.paddingRight = '84px';
    else inp.style.paddingRight = '44px';
    var rec = null;
    b.addEventListener('click', function () {
      if (rec) { try { rec.stop(); } catch (e) {} return; }
      rec = new SR();
      rec.lang = T.sr;
      rec.interimResults = true;
      rec.maxAlternatives = 1;
      var finalText = '';
      b.classList.add('is-on');
      rec.onresult = function (e) {
        var txt = '';
        for (var i = 0; i < e.results.length; i++) txt += e.results[i][0].transcript;
        inp.value = txt;
        if (e.results[e.results.length - 1].isFinal) finalText = txt.trim();
      };
      rec.onerror = function () {};
      rec.onend = function () {
        b.classList.remove('is-on');
        rec = null;
        if (!finalText) return;
        inp.value = finalText;
        if (!ask(form, finalText, true)) { inp.focus(); return; }
      };
      try { rec.start(); } catch (e) { b.classList.remove('is-on'); rec = null; }
    });
  }

  function scan() {
    document.querySelectorAll('form[action$="/search"]').forEach(function (f) {
      if (f.querySelector('input[name="q"]')) setup(f);
    });
  }

  function init() {
    try { if (sessionStorage.getItem(FLAG) === '1') clearWide(); } catch (e) {}
    scan();
    swapIcons();
    watchChat();
    if (!chat()) {
      var n = 0, iv = setInterval(function () { if (chat() || ++n > 20) { clearInterval(iv); watchChat(); } }, 500);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
